export const SEND_MODE = {
  POSTHUMOUS: "posthumous",
  LIFETIME: "lifetime",
};

export const DELIVERY_STATUS = {
  SCHEDULED: "scheduled",
  PENDING: "pending",
  IN_PROGRESS: "in_progress",
  RECEIVED: "received",
};

export const LETTER_STATUS = {
  DRAFT: "draft",
  SCHEDULED: "scheduled",
  SENT: "sent",
};

export function isLifetimeRecipient(recipient) {
  return recipient?.sendMode === SEND_MODE.LIFETIME;
}

export function isPosthumousRecipient(recipient) {
  if (!recipient) return false;
  return !isLifetimeRecipient(recipient);
}

export function getSendableRecipients(recipients = []) {
  return recipients.filter(isPosthumousRecipient);
}

export function canSendLetterNow(_letter, recipients = []) {
  return getSendableRecipients(recipients).length > 0;
}

export function isLetterFullySent(letterStatus, recipients = []) {
  if (letterStatus === LETTER_STATUS.SENT) return true;
  if (!recipients.length) return false;
  return recipients.every(isLifetimeRecipient);
}

export function getSendModeLabel(sendMode) {
  if (sendMode === SEND_MODE.LIFETIME) return "Envoi immédiat";
  return "Après décès";
}

export function getDeliveryStatusLabel(status) {
  switch (status) {
    case DELIVERY_STATUS.PENDING:
      return "En cours…";
    case DELIVERY_STATUS.IN_PROGRESS:
      return "En cours…";
    case DELIVERY_STATUS.RECEIVED:
      return "Reçue";
    case DELIVERY_STATUS.SCHEDULED:
      return "Programmée";
    default:
      return "—";
  }
}

export function isRecipientReceived(recipient) {
  return recipient?.deliveryStatus === DELIVERY_STATUS.RECEIVED;
}

/** Green stroke for recipients with deliveryStatus "received". */
export function recipientReceivedRingClass(recipient, variant = "light") {
  if (!isRecipientReceived(recipient)) return "";
  // Dark chips (sage buttons) need offset so the green ring stays visible.
  if (variant === "dark") {
    return "ring-2 ring-sage ring-offset-2 ring-offset-pageBg";
  }
  return "ring-2 ring-sageDark";
}
